import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@material-ui/core'
import { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { AuthContext } from '../../context/Auth/AuthContext'
import { ButtonPrimary } from '../ButtonPrimary'
import { InputSwitch } from '../InputSwitch'
import { updateHiddenConnectionAnnouncement } from '../../services/connectionAnnouncementPreferences'
import { useStyles } from './style'

function ConnectionAnnouncementModal({
  announcement,
  open,
  onClose,
  whatsAppId
}) {
  const classes = useStyles()
  const history = useHistory()
  const { user } = useContext(AuthContext)
  const [doNotShowAgain, setDoNotShowAgain] = useState(false)

  useEffect(() => {
    if (!whatsAppId) return

    const hiddenIds = user?.hiddenConnectionAnnouncementIds || []
    const hiddenFromBackend = hiddenIds.includes(Number(whatsAppId))
    const hiddenFromStorage =
      localStorage.getItem(
        `doNotShowConnectionAnnouncement_${whatsAppId}`
      ) === 'true'

    setDoNotShowAgain(hiddenFromBackend || hiddenFromStorage)
  }, [whatsAppId, open, user])

  const handleRedirectToConnections = () => {
    const whatsAppName = announcement.title
      .replace('Conexão ', '')
      .replace(' Desconectada', '')
    history.push('/connections', { openQrModalFor: whatsAppName })
    onClose()
  }

  const handleDoNotShowAgainChange = e => {
    const checked = e.target.checked
    setDoNotShowAgain(checked)
    if (whatsAppId) {
      localStorage.setItem(
        `doNotShowConnectionAnnouncement_${whatsAppId}`,
        String(checked)
      )
      updateHiddenConnectionAnnouncement({
        whatsappId: Number(whatsAppId),
        hidden: checked
      }).catch(error => {
        console.error(
          '[ConnectionAnnouncementModal] Erro ao salvar preferência:',
          error
        )
      })
    }
  }

  const hasPermission = () => {
    if (!user) return false
    const allowedRoles = ['admin', 'super', 'conexao']
    return allowedRoles.includes(user.profile)
  }

  if (!hasPermission()) {
    return null
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
    >
      <DialogTitle id="alert-dialog-title" className={classes.dialogTitle}>
        {announcement?.title}
      </DialogTitle>
      <DialogContent className={classes.content} dividers>
        <DialogContentText id="alert-dialog-description">
          {announcement?.text}
        </DialogContentText>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <InputSwitch
          checked={doNotShowAgain}
          onChange={handleDoNotShowAgainChange}
          label="Não exibir novamente"
        />
        <ButtonPrimary
          onClick={handleRedirectToConnections}
          label={'Ir para Conexões'}
          autoFocus
        />
      </DialogActions>
    </Dialog>
  )
}

export default ConnectionAnnouncementModal
